import axios from "axios";
import authHeader from "@/services/auth.header";
import { HTTP } from "@/http/config";
import { AnyObject } from "yup";
const API_URL = HTTP.api_url;
class CirugiasService {
  async getIndex(): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + "cirugias", { headers: authHeader() })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data;
      })
      .catch((error) => {
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }
  async getSearch(search): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + `cirugias`, {
        params: search,
        headers: authHeader(),
      })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data;
      })
      .catch((error) => {
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }
  async getlist(pageNumber): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + `cirugias?page=${pageNumber}`, { headers: authHeader() })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data;
      })
      .catch((error) => {
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }

  async postCreated(cirugias): Promise<AnyObject> {
    const response = await axios
      .post(API_URL + "cirugias", cirugias, { headers: authHeader() })
      .then((response) => {
        // console.log(response.data)
        return response.data;
      })
      .catch((error) => {
        const dataError = error.response.data;
        console.log(dataError);
        return dataError;
      });
    return response;
  }

  async postUpdate(id, cirugias): Promise<AnyObject> {
    const response = await axios
      .put(
        API_URL + `cirugias/${id}`,
        { id: Number(id), ...cirugias },
        { headers: authHeader() },
      )
      .then((response) => {
        //console.log(response.data)
        return response?.data;
      })
      .catch((error) => {
        const dataError = error.response.data;
        console.log(dataError);
        return dataError;
      });
    return response;
  }
  async getEdit(id): Promise<AnyObject[]> {
    const response = await axios
      .get(API_URL + `cirugias/${id}`, { headers: authHeader() })
      .then((response) => {
        return response?.data;
      })
      .catch((error) => {
        const dataError = error.response.data;
        console.log(dataError);
        return dataError;
      });
    return response;
  }

  async getDelete(id): Promise<AnyObject> {
    const response = await axios
      .delete(API_URL + `cirugias/${id}`, { headers: authHeader() })
      .then((response) => {
        return response?.data;
      })
      .catch((error) => {
        const dataError = error.response.data;
        console.log(dataError);
        return dataError;
      });
    return response;
  }

  async getListCirugias(): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + "cirugias/list-cirugia", { headers: authHeader() })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data.data;
      })
      .catch((error) => {
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }
}
export default new CirugiasService();
